const getFeedbackColors = () => {
  return {
    lightSuccess: {
      default: 'green.100',
      _dark: 'green.900',
    },
    success: {
      default: 'green.500',
      _dark: 'green.400',
    },
    successHover: {
      default: 'green.400',
      _dark: 'green.500',
    },
    lightDanger: {
      default: 'red.100',
      _dark: 'red.900',
    },
    danger: {
      default: 'red.500',
      _dark: 'red.200',
    },
    dangerHover: {
      default: 'red.400',
      _dark: 'red.100',
    },
    lightInfo: {
      default: 'blue.100',
      _dark: 'blue.900',
    },
    info: {
      default: 'blue.600',
      _dark: 'blue.400',
    },
    infoHover: {
      default: 'blue.400',
      _dark: 'blue.500',
    },
    lightWarning: {
      default: 'yellow.100',
      _dark: 'yellow.900',
    },
    warning: {
      default: 'yellow.600',
      _dark: 'yellow.400',
    },
    warningHover: {
      default: 'yellow.400',
      _dark: 'yellow.500',
    },
  }
}

export default getFeedbackColors()
